import React from 'react';
import { motion } from 'framer-motion';
import './styles.css';

// Four dots fading in sequence, so at any instant they read as a light-to-dark
// run travelling left to right. Meant for the foot of a list that is appending
// to itself (infinite scroll), where components/pageDataLoader's full-screen
// overlay would blank the content the user is still reading just to say "more is
// coming".
//
// Deliberately NOT components/WormLoader: that one is a 5px three-dot pulse
// sized to sit inside a Button, and its `.dot` class is unscoped, so resizing it
// here would change every button in the app that uses it.
const DOT_COUNT = 4;
// One full fade cycle. The per-dot delay below is a fraction of this, so the
// bright dot sweeps across rather than all four blinking together.
const CYCLE_SECONDS = 1.2;

const DotLoader = ({ size = 10, color = '#636363', gap = 8, className = '' }) => (
  <div className={`dot-loader ${className}`} style={{ gap }}>
    {Array.from({ length: DOT_COUNT }).map((_, index) => (
      <motion.span
        key={index}
        className="dot-loader-dot"
        style={{ width: size, height: size, backgroundColor: color }}
        animate={{ opacity: [0.2, 1, 0.2] }}
        transition={{
          repeat: Infinity,
          duration: CYCLE_SECONDS,
          delay: index * (CYCLE_SECONDS / (DOT_COUNT * 2)),
          ease: 'easeInOut',
        }}
      />
    ))}
  </div>
);

export default DotLoader;
